import { MyLatestSubscriptionStatus } from '../gql/globalTypes';
import { getProductId, legacyProductFamily, legacySubscriptionStatus } from './SubscriptionUtil/legacy/LegacySubscriptionHelpers';
export var getUserSubscriptionStatusV1 = function getUserSubscriptionStatusV1(myLatestSubscriptions) {
  var _subscription2, _subscription3;
  if (!myLatestSubscriptions) {
    return {};
  }
  var cheggStudy = myLatestSubscriptions.cheggStudy,
    cheggWriting = myLatestSubscriptions.cheggWriting,
    cheggMath = myLatestSubscriptions.cheggMath;
  var subscription;
  if (cheggStudy) {
    var _subscription;
    subscription = myLatestSubscriptions.cheggStudy;
    /** User with cancelled/paused CSP and active math or writing should be treated as math/writing user. */
    if (((_subscription = subscription) === null || _subscription === void 0 ? void 0 : _subscription.myLatestSubscriptionStatus) === MyLatestSubscriptionStatus.CANCELLED) {
      if ((cheggMath === null || cheggMath === void 0 ? void 0 : cheggMath.myLatestSubscriptionStatus) === MyLatestSubscriptionStatus.ACTIVE || (cheggMath === null || cheggMath === void 0 ? void 0 : cheggMath.myLatestSubscriptionStatus) === MyLatestSubscriptionStatus.ACTIVE_END_OF_BILLING_CYCLE) {
        subscription = cheggMath;
      } else if ((cheggWriting === null || cheggWriting === void 0 ? void 0 : cheggWriting.myLatestSubscriptionStatus) === MyLatestSubscriptionStatus.ACTIVE || (cheggWriting === null || cheggWriting === void 0 ? void 0 : cheggWriting.myLatestSubscriptionStatus) === MyLatestSubscriptionStatus.ACTIVE_END_OF_BILLING_CYCLE) {
        subscription = cheggWriting;
      }
    }
  } else {
    subscription = cheggMath || cheggWriting;
  }
  var subscriptionStatus = (_subscription2 = subscription) === null || _subscription2 === void 0 ? void 0 : _subscription2.myLatestSubscriptionStatus;
  var subscriptionOrderLineStatus = legacySubscriptionStatus(subscription);
  var subscriptionOrderLineFamilyId = legacyProductFamily(subscription);
  var subscriptionProductFamilyType = (_subscription3 = subscription) === null || _subscription3 === void 0 ? void 0 : _subscription3.productFamilyType;
  var subscriptionProductId = getProductId(subscription);
  return {
    subscriptionStatus: subscriptionStatus,
    subscriptionOrderLineStatus: subscriptionOrderLineStatus,
    subscriptionProductFamilyType: subscriptionProductFamilyType,
    subscriptionProductId: subscriptionProductId,
    subscriptionOrderLineFamilyId: subscriptionOrderLineFamilyId
  };
};
export default getUserSubscriptionStatusV1;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getUserSubscriptionStatusV1.js
// module id = 4131
// module chunks = 11